// extracted by mini-css-extract-plugin
export default {"dataDetailBox":"detail_dataDetailBox__LLAQx","tabWrap":"detail_tabWrap__-bUjW","collectBox":"detail_collectBox__y5oYI","configurationBox":"detail_configurationBox__tBE1X"};